import styled from "@emotion/styled";

export const StyledTdFixedWidth = styled.th({
  width: '10px',
  borderBottom: '1px solid rgba(224, 224, 224, 1)',
});